import Vue from "vue";
import Router from "vue-router";

// PAGES
import MainLayout from "./pages/MainLayout.vue";

// VIEWS
import AboutMe from "./views/AboutMe.vue";
import VInfiniteSlidebarComponent from "./views/VInfiniteSlidebarComponent";

Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [{
    path: "/",
    component: MainLayout,
    children: [{
        path: "",
        name: "AboutMe",
        component: AboutMe,
      },
      {
        path: "v-infinite-slidebar",
        name: "VInfiniteSlidebarComponent",
        component: VInfiniteSlidebarComponent,
      },
    ],
  }, ],
});
